import { createSlice } from '@reduxjs/toolkit';

import type { VerifyAccountForm } from './types';

export const slice = createSlice({
    initialState: {
        VerifyAccountAtom: null as VerifyAccountForm | null
    },

    name: 'useVerifyAccount',

    reducers: {
        VerifyAccountAtom: (state, action) => {
            state.VerifyAccountAtom = action.payload;
        }
    }
});

export default slice.reducer;
